import { Record } from 'immutable';
import { pagingActions, actionTypes } from './responses.actions';
import { pagingDataUtilities } from '../common';

export const ResponsesState = Record({
  pagingData: pagingDataUtilities.PagingState({
    itemsPerPage : 10,
    sortBy : 'date',
    sortAsc : false
  }),
  /** filter option: limits results to responses for this site */
  siteId: '',
  /** filter option: limits results to responses for this program */
  programId: '',
  /** filter option: limits results to responses whose form name partially matches this string */
  nameSearch: '',
});

export const responsesReducer = (initialState = new ResponsesState(), action) => {
  var state = initialState.set('pagingData',
    pagingDataUtilities.pagingReducer(initialState.get('pagingData'), action, pagingActions));

  switch(action.type) {
    case actionTypes.APPLY_FILTER: {
      return state.set('siteId', action.siteId)
                  .set('programId', action.programId)
                  .set('nameSearch', action.search);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/responses/responses.reducer.js